export default __webpack_public_path__ + "static/media/info-icon3.69f48251.svg";